// BIC regex (ISO 9362)
export const isValidBic = (bic?: string): boolean => (
   !!(bic ?? '').trim() &&
   /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test((bic ?? '').trim().toUpperCase())
);


export const isBicRequired = (iban?: string): boolean => (
   iban ? iban.slice(0, 2).toUpperCase() !== 'CH' : false
);